import { useNavigate } from 'react-router-dom';
import { GovIcon } from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useDataBoxMessageFormContext } from '@gov-nx/module/data-box';
import { PageCode } from '@gov-nx/module/page';
import { Button } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { DataBoxMessageForm } from './DataBoxMessageForm';

export const DataBoxMessageAnswerPage = () => {
	const { dataBoxId, folderType, messageId } = useDataBoxMessageFormContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tn = getLocalizeCurried(PageCode['datove-schranky']);
	const navigate = useNavigate();

	return (
		<section className="flex flex-col w-full mt-[-65px] px-(--templates-margin-l) pb-(--templates-margin-l) relative z-200 h-screen bg-(--background-block-primary) [ ds:grow ds:rounded-3xl ds:overflow-hidden ds:mt-0! ds:h-full ds:z-0 ]">
			<div className="flex items-center justify-between h-(--height-5xl)">
				<h2 className="text-body-xl-bold!">{tn('nova-zprava.odpovedet')}</h2>
				<Button
					onClick={() =>
						navigate(
							pageRouteResolver('datove-schranky.schranka.zprava', {
								dataBoxId,
								folderType,
								messageId,
							})
						)
					}
					className="[ ds:hidden! ]"
					aria-label={tn('nova-zprava.zahodit')}
					type="base"
					size="s"
					nativeType="button"
					color="primary"
					iconStart={
						<GovIcon
							name="x-lg"
							type="components"
						/>
					}
				/>
			</div>
			<div className="flex h-[calc(100%-54px)] mt-0!">
				<DataBoxMessageForm />
			</div>
		</section>
	);
};
